export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-user-heart-line',
      title: 'Client-Centric Approach',
      description: 'Your goals drive our strategy. We listen, adapt, and deliver solutions that align with your vision and business needs.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Full-Service Capability',
      description: 'From web development to agribusiness transformation — we offer integrated support across the entire value chain.'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Innovation & Expertise',
      description: 'We combine cutting-edge technology with deep industry knowledge to deliver solutions that work in the real world.'
    },
    {
      icon: 'ri-team-line',
      title: 'Proven Track Record',
      description: 'Over 10 years of experience, 500+ projects delivered, and a 98% client satisfaction rate speak for themselves.'
    },
    {
      icon: 'ri-time-line',
      title: 'Timely Delivery',
      description: 'We respect deadlines and deliver on time, every time — without compromising on quality or attention to detail.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Our team is always available to assist you. Whether it\'s a question or an urgent issue, we\'re here to help.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="w-full px-4 sm:px-8 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3782df]/10 rounded-full mb-6">
            <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
            <span className="text-[#3782df] text-sm font-medium">Why Choose Us</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            What Sets Us Apart
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            We don't just deliver projects — we build partnerships. Here's why businesses trust LumanyiTech.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-[#3782df]/10 rounded-lg flex items-center justify-center mb-4">
                <i className={`${reason.icon} text-2xl text-[#3782df]`}></i>
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}